import React, { Component } from 'react';
import { Facebook, Twitter, Linkedin, Mail } from 'lucide-react';
interface SocialShareButtonsProps {
  url: string;
  title: string;
  excerpt?: string;
  onShare?: (platform: string) => void;
}
const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({
  url,
  title,
  excerpt = '',
  onShare
}) => {
  const handleShare = (platform: string, shareUrl: string) => {
    window.open(shareUrl, '_blank', 'width=600,height=400');
    if (onShare) {
      onShare(platform);
    }
  };
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedExcerpt = encodeURIComponent(excerpt);
  return <div className="flex space-x-3" data-id="element-104">
      <button onClick={() => handleShare('facebook', `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`)} className="text-white bg-[#3b5998] hover:bg-[#2d4373] p-2 rounded-full" aria-label="Share on Facebook" data-id="element-105">
        <Facebook size={18} data-id="element-106" />
      </button>
      <button onClick={() => handleShare('twitter', `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`)} className="text-white bg-[#1da1f2] hover:bg-[#0c85d0] p-2 rounded-full" aria-label="Share on Twitter" data-id="element-107">
        <Twitter size={18} data-id="element-108" />
      </button>
      <button onClick={() => handleShare('linkedin', `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}&summary=${encodedExcerpt}`)} className="text-white bg-[#0077b5] hover:bg-[#005582] p-2 rounded-full" aria-label="Share on LinkedIn" data-id="element-109">
        <Linkedin size={18} data-id="element-110" />
      </button>
      <button onClick={() => handleShare('email', `mailto:?subject=${encodedTitle}&body=${encodedExcerpt}%0A%0A${encodedUrl}`)} className="text-white bg-[#777] hover:bg-[#555] p-2 rounded-full" aria-label="Share via Email" data-id="element-111">
        <Mail size={18} data-id="element-112" />
      </button>
    </div>;
};
export default SocialShareButtons;